module.exports = __webpack_public_path__ + "img/challenge.8323be6f.jpg";